import React, { Component } from 'react';
import queryString from 'query-string';
import { withTransaction } from '@elastic/apm-rum-react';

import cebLogo from './ceb-logo.svg';
import './SignUp.css';

import SignUpForm from '../SignUpForm';
import config from '../../config';

class SignUp extends Component {
  constructor(props) {
    super(props);
    const { location = {} } = this.props;
    const query = queryString.parse(location.search);
    if (!query.board || !query.state) {
      window.location.href = `${config.HOME_URL}/providers`;
    }

    this.state = {
      currentStep: parseInt(query.currentStep, 10) || 1,
      board: parseInt(query.board, 10) || null,
      boardName: query.boardName || '',
      state: parseInt(query.state, 10) || null,
    };

    this.steps = ['Provider Information', 'Access Information'];
  }

  onStepChange = (newStep) => {
    window.scrollTo(0, 0);
    this.setState({ currentStep: newStep });
  };

  render() {

    if (!this.state.board || !this.state.state) {
      return false;
    }

    return (
      <section>
        <header className="header">
          <div className="center">
            <img src={cebLogo} alt="Propelus CE Broker logo" />
          </div>
        </header>
        <div className="form-title">
          <p>Now, let's set up your board profile</p>
          <p>{this.state.boardName}</p>
        </div>
        <SignUpForm
          onStepChange={this.onStepChange}
          currentStep={this.state.currentStep}
          steps={this.steps}
          board={this.state.board}
          state={this.state.state}
        />
      </section>
    );
  }
}

export default withTransaction('SignUp', 'page_component')(SignUp);



// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js